import { useState } from "react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import SocialIcons from "../components/SocialIcons";
import { contact, feature } from "../data/site";

const Field = ({ label, ...props }) => (
  <label className="block">
    <span className="eyebrow mb-2 block">{label}</span>
    {props.as === "textarea" ? (
      <textarea
        {...props}
        rows={4}
        className="w-full border border-charcoal/20 bg-white px-4 py-3 font-sans text-sm text-charcoal placeholder-charcoal/40 outline-none transition-colors focus:border-gold"
      />
    ) : (
      <input
        {...props}
        className="w-full border border-charcoal/20 bg-white px-4 py-3 font-sans text-sm text-charcoal placeholder-charcoal/40 outline-none transition-colors focus:border-gold"
      />
    )}
  </label>
);

export default function Contact() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const onSubmit = (e) => {
    e.preventDefault();
    // No backend yet — compose a mailto so enquiries reach the house inbox.
    const body = encodeURIComponent(
      `Name: ${form.name}\nEmail: ${form.email}\nPhone: ${form.phone}\n\n${form.message}`
    );
    window.location.href = `mailto:${contact.email}?subject=Private%20Enquiry%20%E2%80%94%20Culture%20Antique&body=${body}`;
    setSent(true);
  };

  return (
    <>
      <PageHero
        eyebrow="The Experience"
        title="Book a private viewing"
        subtitle="Discreet, by-appointment consultations at our Ahmedabad showroom. Tell us what you envision and our atelier will be in touch."
        image={feature.heroContact}
      />

      <section className="py-24">
        <div className="container-luxe grid gap-16 lg:grid-cols-2 lg:gap-24">
          {/* Details */}
          <Reveal>
            <p className="eyebrow mb-5">Visit &amp; Enquire</p>
            <h2 className="section-title mb-10">We would love to meet you</h2>

            <div className="space-y-8">
              <Detail label="Atelier">
                {contact.addressLines.map((l) => (
                  <span key={l} className="block">
                    {l}
                  </span>
                ))}
              </Detail>
              <Detail label="Telephone">
                <a href={`tel:${contact.phone.replace(/\s/g, "")}`} className="hover:text-gold">
                  {contact.phone}
                </a>
              </Detail>
              <Detail label="Email">
                <a href={`mailto:${contact.email}`} className="hover:text-gold">
                  {contact.email}
                </a>
              </Detail>
              <Detail label="Hours">{contact.hours}</Detail>
            </div>

            <div className="mt-10">
              <p className="eyebrow mb-4">Follow</p>
              <SocialIcons tone="dark" />
            </div>
          </Reveal>

          {/* Form */}
          <Reveal delay={150}>
            <div className="border border-gold/20 bg-cream p-8 md:p-10">
              {sent ? (
                <div className="flex h-full min-h-[420px] flex-col items-center justify-center text-center">
                  <span className="mb-6 flex h-16 w-16 items-center justify-center rounded-full border border-gold text-gold">
                    <svg viewBox="0 0 24 24" className="h-7 w-7" stroke="currentColor" strokeWidth="1.3" fill="none">
                      <path d="M5 12l4 4 10-10" />
                    </svg>
                  </span>
                  <h3 className="mb-3 font-serif text-3xl font-light">Thank you</h3>
                  <p className="max-w-sm font-sans text-sm font-light leading-relaxed text-charcoal/60">
                    Your enquiry is on its way. Our atelier will respond within one
                    business day to arrange your private viewing.
                  </p>
                </div>
              ) : (
                <form onSubmit={onSubmit} className="space-y-6">
                  <Field
                    label="Full Name"
                    type="text"
                    required
                    placeholder="Your name"
                    value={form.name}
                    onChange={update("name")}
                  />
                  <div className="grid gap-6 sm:grid-cols-2">
                    <Field
                      label="Email"
                      type="email"
                      required
                      placeholder="you@email.com"
                      value={form.email}
                      onChange={update("email")}
                    />
                    <Field
                      label="Phone"
                      type="tel"
                      placeholder="+91"
                      value={form.phone}
                      onChange={update("phone")}
                    />
                  </div>
                  <Field
                    label="Your Vision"
                    as="textarea"
                    required
                    placeholder="Tell us about the piece you have in mind…"
                    value={form.message}
                    onChange={update("message")}
                  />
                  <button type="submit" className="btn-gold w-full">
                    Send Enquiry
                  </button>
                </form>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}

function Detail({ label, children }) {
  return (
    <div>
      <p className="eyebrow mb-2">{label}</p>
      <p className="font-serif text-xl font-light leading-relaxed text-charcoal/85">
        {children}
      </p>
    </div>
  );
}
